module.exports = __webpack_public_path__ + "media/svgs/smiley-happy-aeeacabaaaf7a3a8b0f915a68d62d530.svg";